import { SetStateAction } from 'react';
import api from 'api/api';
import { AxiosStatus } from 'api/axiosConfig';
import { NETWORK_REQUIRED } from './constants';
import { IApiResponse } from './models';

export default function validateOtpPin(otp: string) {
  return api.post(`customer/otp/verify/${otp || ''}/false/${String(sessionStorage.getItem('userName'))}`, {
    otpPin: otp,
  });
}

export function handlePinError(
  setSubmitStatus: (status: SetStateAction<AxiosStatus>) => void,
  setErrorMsg: (message: SetStateAction<string>) => void,
) {
  return (error: IApiResponse) => {
    if (error.failureCount === 1) {
      setSubmitStatus(AxiosStatus.FIRST_WRONG_OTP);
    } else if (error.failureCount === 2) {
      setSubmitStatus(AxiosStatus.SECOND_WRONG_OTP);
    } else if (error.failureCount === 0) {
      setSubmitStatus(AxiosStatus.FAILURE);
      setErrorMsg(error.description || NETWORK_REQUIRED);
    } else {
      setSubmitStatus(AxiosStatus.FAILURE);
      setErrorMsg(error.description || NETWORK_REQUIRED);
    }
  };
}
